import { render } from "./AdminMyEvents.vue?vue&type=template&id=36eb007e&scoped=true"
import script from "./AdminMyEvents.vue?vue&type=script&lang=js"
export * from "./AdminMyEvents.vue?vue&type=script&lang=js"

import "./AdminMyEvents.vue?vue&type=style&index=0&id=36eb007e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eb007e"]])

export default __exports__